import React from 'react';

import { Box, ButtonBase } from '@mui/material';
import { Add } from 'iconsax-react';

import { useTheme } from 'third-party';

type Props = {
  onClick: () => void;
};

export const PlaceholderButton: React.FC<Props> = ({ onClick }) => {
  const theme = useTheme();
  return (
    <ButtonBase
      onClick={ev => {
        ev.stopPropagation();
        onClick();
      }}
      sx={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        height: 48,
        width: '100%',
        bgcolor: theme.custom.palette.primary300,
      }}
    >
      <Box
        sx={{
          p: 0.12,
          bgcolor: 'brand.blue',
          borderRadius: 24,
          color: 'primary.contrastText',
          display: 'flex',
        }}
      >
        <Add variant="TwoTone" size="20" />
      </Box>
    </ButtonBase>
  );
};
